import { z } from 'zod'

const YYYY_MM = /^\d{4}-(0[1-9]|1[0-2])$/

export const createDateRangeSchema = (maxRangeMonths = 11) =>
  z
    .object({
      fechaDesde: z.string().min(1, 'La fecha de inicio es requerida').regex(YYYY_MM, 'Formato de fecha inválido'),
      fechaHasta: z.string().min(1, 'La fecha de fin es requerida').regex(YYYY_MM, 'Formato de fecha inválido'),
    })
    .refine((data) => data.fechaDesde <= data.fechaHasta, {
      message: 'La fecha hasta debe ser posterior a la fecha desde',
      path: ['fechaHasta'],
    })
    .refine(
      (data) => {
        const [fromYear, fromMonth] = data.fechaDesde.split('-').map(Number)
        const [toYear, toMonth] = data.fechaHasta.split('-').map(Number)
        const diffMonths = (toYear - fromYear) * 12 + (toMonth - fromMonth)
        return diffMonths <= maxRangeMonths
      },
      {
        message: `El rango no puede superar los ${maxRangeMonths + 1} meses`,
        path: ['fechaHasta'],
      }
    )

export const dateRangeSchema = createDateRangeSchema(11)
